// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: gZEhwnQAfx2q6zBpBNhhDQ
// Component: japjhC-77smV
import * as React from "react";
import {
  Stack as Stack__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  renderPlasmicSlot
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import CompletedSign from "../../CompletedSign"; // plasmic-import: RMvi0OvU26Cg/component
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_collect_wise_draft.module.css"; // plasmic-import: gZEhwnQAfx2q6zBpBNhhDQ/projectcss
import sty from "./PlasmicContractsListCard.module.css"; // plasmic-import: japjhC-77smV/css

createPlasmicElementProxy;

export const PlasmicContractsListCard__VariantProps = new Array();

export const PlasmicContractsListCard__ArgProps = new Array(
  "title",
  "client",
  "totalAmount",
  "date"
);

const $$ = {};

function PlasmicContractsListCard__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  return (
    <Stack__
      as={"div"}
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      hasGap={true}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        sty.root
      )}
    >
      <div className={classNames(projectcss.all, sty.freeBox__e2B9L)}>
        {renderPlasmicSlot({
          defaultContents: "Social Media Marketing",
          value: args.title,
          className: classNames(sty.slotTargetTitle)
        })}
      </div>
      <div className={classNames(projectcss.all, sty.freeBox___56X3)}>
        {renderPlasmicSlot({
          defaultContents: "Nike",
          value: args.client,
          className: classNames(sty.slotTargetClient)
        })}
      </div>
      <div
        data-plasmic-name={"contractStatusStack"}
        data-plasmic-override={overrides.contractStatusStack}
        className={classNames(projectcss.all, sty.contractStatusStack)}
      >
        <CompletedSign
          data-plasmic-name={"completedSign"}
          data-plasmic-override={overrides.completedSign}
          className={classNames("__wab_instance", sty.completedSign)}
        />
      </div>
      <div className={classNames(projectcss.all, sty.freeBox__oKjYp)}>
        {renderPlasmicSlot({
          defaultContents: "$1024.00",
          value: args.totalAmount,
          className: classNames(sty.slotTargetTotalAmount)
        })}
      </div>
      <div className={classNames(projectcss.all, sty.freeBox__vVjy6)}>
        {renderPlasmicSlot({
          defaultContents: "Dec 28th, 12:25 AM",
          value: args.date,
          className: classNames(sty.slotTargetDate)
        })}
      </div>
    </Stack__>
  );
}

const PlasmicDescendants = {
  root: ["root", "contractStatusStack", "completedSign"],
  contractStatusStack: ["contractStatusStack", "completedSign"],
  completedSign: ["completedSign"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicContractsListCard__ArgProps,
          internalVariantPropNames: PlasmicContractsListCard__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicContractsListCard__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicContractsListCard";
  } else {
    func.displayName = `PlasmicContractsListCard.${nodeName}`;
  }
  return func;
}

export const PlasmicContractsListCard = Object.assign(
  // Top-level PlasmicContractsListCard renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    contractStatusStack: makeNodeComponent("contractStatusStack"),
    completedSign: makeNodeComponent("completedSign"),
    // Metadata about props expected for PlasmicContractsListCard
    internalVariantProps: PlasmicContractsListCard__VariantProps,
    internalArgProps: PlasmicContractsListCard__ArgProps
  }
);

export default PlasmicContractsListCard;
/* prettier-ignore-end */
